var FormLocationService = /** @class */ (function () {
    function FormLocationService() {
    }
    FormLocationService.getInstance = function () {
        if (!FormLocationService.instance) {
            FormLocationService.instance = new FormLocationService();
        }
        return FormLocationService.instance;
    };
    FormLocationService.prototype.getLocation = function () {
        var location = window.location.href
            .replace(window.location.origin + '/', '')
            .replaceAll('/', '|');
        if (location != null && location.indexOf('?') > 0) {
            location = location.substring(0, location.indexOf('?'));
        }
        return location;
    };
    return FormLocationService;
}());
export { FormLocationService };



//////////////////
// WEBPACK FOOTER
// ./services/form-location.service.ts
// module id = 66
// module chunks = 0